import { Button, ContentLayout, Logo, PageLayout } from 'components';
import style from './index.module.scss';
import { useNavigate } from 'react-router-dom';

const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <PageLayout>
      <ContentLayout>
        <div className={style.notfound}>
          <Logo />
          <h1>404 - PAGE NOT FOUND</h1>
          <Button onClick={() => navigate('/')}> INICIO </Button>
        </div>
      </ContentLayout>
    </PageLayout>
  );
};

export default PageNotFound;
